module.exports = __webpack_public_path__ + "static/media/runway_ai.798567a9.png";